import { Modal, SlideDown } from '@globalmed/atlas-ui';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoText } from './components/InfoText';
import { useMediaQuery } from '@/hooks/useMediaQuery';

type TProps = {
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
};

/**
 * Renders a help information modal with contact details for the institution.
 * Uses SlideDown for small screens and Modal for larger screens.
 * @param props - Component props.
 * @param props.open - Controls whether the modal is open.
 * @param props.onOpenChange - Callback to update the open state.
 * @returns HelpInfoModal component.
 */
export const HelpInfoModal = (props: TProps) => {
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery('(max-width: 576px)');
  const ModalComponent = isSmallScreen ? SlideDown : Modal;

  return (
    <ModalComponent
      {...props}
      title={t('need-help')}
      body={
        <div>
          <InfoText onClose={() => props.onOpenChange(false)} />
        </div>
      }
    />
  );
};
